/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const putApiProjectprioritiesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const putApiProjectprioritiesId200Schema = z.any();

export const putApiProjectprioritiesIdMutationRequestSchema = z.object({
  name: z.coerce.string(),
});

export const putApiProjectprioritiesIdMutationResponseSchema = z.lazy(
  () => putApiProjectprioritiesId200Schema,
);
